import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Table, Typography, Empty } from 'antd';
import Icofont from 'react-icofont';

import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';

import {
    MoreOutlined
} from '@ant-design/icons';



import {Action, deleteInArray, updateInArray} from 'fennec-ui'
import {DropdownAction} from 'fennec-ui'
import MeropriyatieFileUpload from '../MeropriyatieFileUpload'
import SsilokNaFailiChangeName from '../SsilokNaFailiChangeName'
import { errorCatch, GET, POST, POSTFormData } from 'fennec-ui'

import "./index.css"

const { Link } = Typography;

const DragHandle = sortableHandle(() => <Icofont icon="expand-alt" style={{ cursor: 'grabbing', color: '#999' }} />);
const SortableItem = sortableElement(props => <tr {...props} />);
const SortableContainer = sortableContainer(props => <tbody {...props} />);


export default function SsilokNaFaili(props) {
    const [loading, setLoading] = useState(false);
    const { auth, object, sourceKey, create, collection, updateEvent } = props;
    const dispatch = useDispatch();

    const _ssilki = (object.ssilkiNaFailiMeropriyatie) ? [...object.ssilkiNaFailiMeropriyatie] : [];
    const ssilki = _ssilki.sort((a,b)=>{
        return a.sort - b.sort;
    }).map((item, index) => {
        return {...item, sort: index};
    });

    const deleteFile = (kat) => {
        if (!create) return;
        GET(auth, "/api/meropriyatiya/file/delete/" + kat.ID,
            () => {
                updateEvent({
                    ...object,
                    ssilkiNaFailiMeropriyatie: deleteInArray(object.ssilkiNaFailiMeropriyatie, kat)
                })
            },
            (err)=>errorCatch(err));
    };
    const updateFile = (record, values, unlock, close) => {
        if (!create) return;
        POST(auth, "/api/meropriyatiya/file/update", { ...record, ...values},
            ({data}) => {
                if (data) {
                    updateEvent({
                        ...object,
                        ssilkiNaFailiMeropriyatie: updateInArray(object.ssilkiNaFailiMeropriyatie, data)
                    })
                }
                close();
            },
            (err)=>errorCatch(err, unlock));
    };
    const postSetOrder = (ssilki) => {
        if (!create) return;
        setLoading(true);
        POST(auth, "/api/meropriyatiya/file/sort", ssilki,
            ({data}) => {
                updateEvent({
                    ...object,
                    ssilkiNaFailiMeropriyatie: data
                })
                setLoading(false);
            },
            (err)=>errorCatch(err, setLoading(false)));
    };
    const columns = () => {
        var c = [];
        var bucketName = "federation"
        if (auth.appProfile != "prod") {
            bucketName = "federation-dev"
        }

        if (create) {
            c.push({
                width: 30,
                className: 'drag-visible',
                render: () => <DragHandle />,
            });
        }
        c.push({
            title: 'Название',
            render: (text, record) => {
                return (
                    <div>
                        <Link href={"https://storage.yandexcloud.net/" + bucketName + "/" + record.ssilka} target="_blank">
                            {record.nazvanie}
                        </Link>
                    </div>
                );
            },
            key: 'nazvanie',
        });
        c.push({
            title: 'Тип файла',
            render: (text, record) => {
                return (
                    <div>
                        {record.tipSsilki.opisanie}
                    </div>
                );
            },
            key: 'tipSsilki',
        });
        if (create) {
            // c.push({
            //     title: '',
            //     dataIndex: '',
            //     key: 'move',
            //     fixed: 'right',
            //     width: 45,
            //     render: (text, record) => {
            //         return (<div style={{lineHeight: "0"}}>
            //             <Button type="text" style={{padding: "0px 4px", height: "100%", lineHeight: "0"}} onClick={() => moveSsilka("up", record)}><Icofont icon="caret-up"/></Button>
            //             <Button type="text" style={{padding: "0px 4px", height: "100%", lineHeight: "0"}} onClick={() => moveSsilka("down", record)}><Icofont icon="caret-down"/></Button>
            //             </div>
            //         );
            //     },
            // });
            c.push({
                title: '',
                dataIndex: '',
                key: 'x',
                fixed: 'right',
                width: 45,
                render: (text, record) => {
                    return (
                        <DropdownAction icon={<MoreOutlined />} buttonStyle={{ border: "none" }} items={[
                            {
                                ...props,
                                readonly: false,
                                mode: "MenuItem",
                                auth: auth,
                                context: object,
                                object: record,
                                action: (values, unlock, close) => updateFile(record, values, unlock, close),
                                form: SsilokNaFailiChangeName,
                                title: "Изменить",
                                modal: {
                                    title: "Изменить",
                                    minWidth: "600px",
                                }
                            },
                            {
                                title:"Удалить",
                                mode: "MenuItem",
                                action:() => deleteFile(record)
                            }
                        ]}/>);
                },
            });
        }

        return c;
    };
    const createAction = (values, unlock, close) => {
        // console.log(values);
        
        //отправить новый файл
        if (!create) return;
        POSTFormData(auth, "/api/meropriyatiya/upload", values,
            ({data}) => {
                if (data) {
                    var kat = (object.ssilkiNaFailiMeropriyatie) ? [...object.ssilkiNaFailiMeropriyatie] : [];
                    var ok = false;
                    if (kat) {
                        for (let i = 0; i < kat.length; i++) {
                            const k = kat[i];
                            if (k.ID === data.ID) {
                                kat[i] = data;
                                ok = true;
                            }
                        }
                    }
                    if (!ok) {
                        kat.push(data);
                    }
                    updateEvent({
                        ...object,
                        ssilkiNaFailiMeropriyatie: kat
                    });
                }
                close();
            },
            (err)=>errorCatch(err, unlock));
    };

    const onSortEnd = ({ oldIndex, newIndex }) => {
        const dataSource = ssilki;
        if (oldIndex !== newIndex) {
            const newData = arrayMoveImmutable([].concat(dataSource), oldIndex, newIndex).filter(el => !!el);
            postSetOrder(newData);
        }
    };
    
    const DraggableContainer = props => (
        <SortableContainer
          useDragHandle
          disableAutoscroll
          helperClass="row-dragging"
          onSortEnd={onSortEnd}
          {...props}
        />
    );
    
    const DraggableBodyRow = ({ className, style, ...restProps }) => {
        const dataSource = ssilki;
        // function findIndex base on Table rowKey props and should always be a right array index
        const index = dataSource.findIndex(x => x.sort === restProps['data-row-key']);
        return <SortableItem index={index} {...restProps} />;
    };

    return (
        <>
            {create && <Action 
            // {...props}
                readonly={false}
                triggerStyle={{ marginBottom: "5px" }}
                triggerOptions={{
                    type: "primary"
                }}
                auth={auth}
                context={object}
                action={createAction}
                isFormData={true}
                form={MeropriyatieFileUpload}
                title={"Добавить файл"}
                modal={{
                    minWidth: "600px",
                }}
                mode={"button"}
            />}
            <Table
                loading={loading}
                columns={columns()}
                pagination={false}
                dataSource={ssilki}
                locale={{ emptyText: <Empty description={"Нет файлов"}></Empty> }}
                size="small"
                rowKey={(r) => r.sort} 
                components={{
                    body: {
                      wrapper: DraggableContainer,
                      row: DraggableBodyRow,
                    },
                  }}
                />
        </>
    );
}
